import { useFormContext } from 'react-hook-form'

import { Switch } from 'components/Form'
import { DomainBidderSlice } from 'features/inventory/domain/forms/PrebidStackForm'
import { Schema } from 'features/inventory/domain/forms/PrebidStackForm/schema'
import { useAbility } from 'providers/casl'

type Props = Pick<DomainBidderSlice, 'id' | 'status'>

export const S2sEnabledCell = ({ id, status }: Props): JSX.Element => {
  const ability = useAbility()
  const disabled = status !== 'available' || !ability.can('update', 'GlobalSetupFeature-bidder')
  const { control } = useFormContext<Schema>()

  return (
    <Switch<Schema>
      control={control}
      disabled={disabled}
      name={`domainBiddersAttributes.${id}.s2sEnabled`}
    />
  )
}
